import React from "react";
import useTranslationHook from "../../hooks/useTranslationHook";
import { Link } from "react-router-dom";
// ADREC: handleContactUsModal / handleDeleteAccountModal and the `dispatch` they
// needed are unused now that Contact Us and Delete Account are gone from the footer.
// Restore these three lines together with whichever link is being reinstated.
// import {
//     handleContactUsModal,
//     handleDeleteAccountModal,
// } from "../../../redux/slice/modalSlice";
// ADREC: `useDispatch` dropped from this import along with the `dispatch` call
// below -- nothing in the footer dispatches any more. Original:
// import { useDispatch, useSelector } from "react-redux";
import { useSelector } from "react-redux";
// import ContactUsModal from "../ContactUsModal";
import moment from "moment";
import { useTheme } from "../../../context/ThemeContext";
import DeleteAccountModal from "../DeleteAccount";

const Footer = () => {
    const { t } = useTranslationHook();
    // const dispatch = useDispatch();
    const { assets } = useTheme();
    const deleteAccountModal = useSelector(
        (state) => state.modal.deleteAccountModal
    );
    const quickLinksFirst = [
        {
            label: "About Us",
            url: "/about-us",
        },
        // ADREC: Contact Us removed from the footer. The /support route is still
        // registered and reachable by direct URL.
        // {
        //     label: "Contact Us",
        //     url: "/support",
        // },
        // {
        //     label: "Clients",
        //     url: "/clients",
        // },
        {
            label: "Terms & Conditions",
            url: "/terms-and-condition",
        },
    ];
    const quickLinksSecond = [
        {
            label: "Privacy Policy",
            url: "/privacy-policy",
        },
        // ADREC: FAQs and Delete Account removed from the footer. /faq is still
        // registered; the delete-account modal is still reachable from
        // AccountVerifiedStatusModal, which is why <DeleteAccountModal /> stays
        // mounted at the bottom of this component -- it is that flow's only mount
        // point, so removing it would break account deletion entirely.
        // {
        //     label: "FAQs",
        //     url: "/faq",
        // },
        // {
        //     label: "Delete Account",
        //     url: "",
        //     onClick: (e) => {
        //         e.preventDefault();
        //         dispatch(handleDeleteAccountModal(true));
        //     },
        // },
        // {
        //     label: "Blog",
        //     url: "/blog",
        // },
    ];
    // ADREC: social media icons removed from the footer.
    // const socialLink = [
    //     {
    //         className: "fab fa-facebook-f",
    //         url: "https://www.facebook.com",
    //     },
    //     {
    //         className: "fa-brands fa-x-twitter",
    //         url: "https://www.twitter.com",
    //     },
    //     {
    //         className: "fa-brands fa-instagram",
    //         url: "https://www.instagram.com",
    //     },
    // ];
    return (
        <footer className="footer ">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-md-6">
                        <h2 className="mb-4">
                            <img
                                src={assets.logoFooter}
                                className="footer-logo"
                                alt="Auction Logo"
                            />
                        </h2>
                        <p className="mb-4">
                            {t("Our trusted platform for seamless property")}{" "}
                            <br />
                            {t("auctions. Buy, sell, and bid with confidence.")}
                        </p>
                        {/* ADREC: social media icons removed.
                        <div className="social-links d-flex">
                            {socialLink.map((item, index) => {
                                return (
                                    <Link
                                        className="mr-4"
                                        key={index + item.className}
                                        to={item?.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className={item.className}></i>
                                    </Link>
                                );
                            })}
                        </div> */}
                    </div>

                    <div className="col-lg-2 col-md-6">
                        {quickLinksFirst.map((item, index) => {
                            return (
                                <Link
                                    className="btn-link"
                                    to={item?.url}
                                    key={index + item.label}
                                    onClick={item?.onClick}
                                >
                                    {t(`${item.label}`)}
                                </Link>
                            );
                        })}
                    </div>
                    <div className="col-lg-2 col-md-6">
                        {quickLinksSecond.map((item, index) => {
                            return (
                                <>
                                    {
                                        <Link
                                            className="btn-link"
                                            to={item?.url}
                                            key={index + item.label}
                                            onClick={item?.onClick}
                                        >
                                            {t(`${item.label}`)}
                                        </Link>
                                    }
                                </>
                            );
                        })}
                    </div>
                    {/* ADREC: App Store / Google Play badges removed. The surrounding
                        row now spans 5+2+2 of 12 columns, leaving 3 unused -- purely
                        cosmetic, no layout redesign attempted here.
                    <div className="col-lg-3 col-md-6">
                        <div className="app-btns">
                            <a
                                href="https://apps.apple.com/pk/app/propify/id6754378614"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="app-link mb-3"
                            >
                                <img
                                    src="/img/appstore-icon.svg"
                                    alt="App Store"
                                />
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.adres.auction&pcampaignid=web_share"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="app-link"
                            >
                                <img src="/img/googleplay-icon.svg" alt="" />
                            </a>
                        </div>
                    </div> */}
                </div>
                {/* <ContactUsModal
                    title={"Anything on your mind? Just reach out!"}
                    content={
                        "our support team is available 9am - 6pm Sunday to Saturday."
                    }
                    handleModalCancel={() =>
                        dispatch(handleContactUsModal(false))
                    }
                    handleModalOpen={() => dispatch(handleContactUsModal(true))}
                /> */}
            </div>

            <div className="container">
                <div className="col-lg-12">
                    <div className="copyright">
                        {t("Copyright Label", {
                            dynamicYear: moment().locale("en").format("YYYY"),
                        })}
                    </div>
                </div>
            </div>
            {deleteAccountModal ? <DeleteAccountModal /> : <></>}
        </footer>
    );
};

export default Footer;
